import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedFacade } from '@piqet-angular/data';
import { ADMIN_EOL_CONSUMER, CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-add-eol',
  templateUrl: './add-eol.component.html',
  styleUrls: ['./add-eol.component.scss'],
})
export class AddEolComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  adminMaterialData: any;
  materialForm!: FormGroup;
  materialAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationList: any;
  materialList: any;
  isEolRates: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  selectedMaterial: any;
  setIndicatorData: any;
  addEditEndpoint: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewEolEvent = new EventEmitter<any>();

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private sharedFacade: SharedFacade,
    private administratorService: AdministratorService,
    private router: Router
  ) {
    let urlSlash = this.router.url.lastIndexOf('/');
    let path = this.router.url.slice(urlSlash + 1);
    this.adminMaterialData = this.modal?.modalService?.config?.initialState?.['eolModalData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel.includes('Review') ? true : false;
    switch (path) {
      case 'admin-eol-rc':
        this.addEditEndpoint = '/EOL_RC/AddUpdateEndofLifeRC';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL recycling') : this.modalLabel;
        break;
      case 'admin-eol-lf':
        this.addEditEndpoint = '/EOL_LF/AddUpdateEndofLifeLF';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL landfill') : this.modalLabel;
        break;
      case 'admin-eol-cc':
        this.addEditEndpoint = '/EOL_CC/AddUpdateEndofLifeCC';
        !this.isDisabledDropDown
          ? (this.modalLabel = 'Add new EOL commercial composting')
          : this.modalLabel;
        break;
      case 'admin-eol-hc':
        this.addEditEndpoint = '/EOL_HC/AddUpdateEndofLifeHC';
        !this.isDisabledDropDown
          ? (this.modalLabel = 'Add new EOL home composting')
          : this.modalLabel;
        break;
      case 'admin-eol-er':
        this.addEditEndpoint = '/EOL_ER/AddUpdateEndofLifeER';
        !this.isDisabledDropDown
          ? (this.modalLabel = 'Add new EOL waste energy recovery')
          : this.modalLabel;
        break;
      case 'admin-eol-ic':
        this.addEditEndpoint = '/EOL_IC/AddUpdateEndofLifeIC';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL incineration') : this.modalLabel;
        break;
      case 'admin-eol-od':
        this.addEditEndpoint = '/EOL_OD/AddUpdateEndofLifeOD';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new open dump') : this.modalLabel;
        break;
      case 'admin-eol-sw':
        this.addEditEndpoint = '/EOL_SW/AddUpdateEndofLifeSW';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL storm water') : this.modalLabel;
        break;
      case 'admin-eol-se':
        this.addEditEndpoint = '/EOL_SE/AddUpdateEndofLifeSE';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL sewer') : this.modalLabel;
        break;
      case 'admin-eol-lt':
        this.addEditEndpoint = '/EOL_LT/AddUpdateEndofLifeLT';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL litter') : this.modalLabel;
        break;
      case 'admin-eol-ad':
        this.addEditEndpoint = '/EOL_AD/AddUpdateEndofLifeAD';
        !this.isDisabledDropDown
          ? (this.modalLabel = 'Add new EOL anerobic digestion')
          : this.modalLabel;
        break;
      case 'admin-eol-rates':
        this.addEditEndpoint = '/EOLRates/AddUpdateEOLImpactRates';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL rates') : this.modalLabel;
        break;
      case ADMIN_EOL_CONSUMER:
        this.addEditEndpoint = '/EOLConsumerRates/AddUpdateEOLImpactConsumerRates';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL consumers') : this.modalLabel;
        break;
      case 'admin-eol-or':
        this.addEditEndpoint = '/EOL_OR/AddUpdateEndofLifeOR';
        !this.isDisabledDropDown
          ? (this.modalLabel = 'Add new EOL recycling open loop')
          : this.modalLabel;
        break;
      case 'admin-eol-cr':
        this.addEditEndpoint = '/EOL_CR/AddUpdateEndofLifeCR';
        !this.isDisabledDropDown
          ? (this.modalLabel = 'Add new EOL chemical recycling')
          : this.modalLabel;
        break;
      case 'admin-eol-pg':
        this.addEditEndpoint = '/EOL_PG/AddUpdateEndofLifePG';
        !this.isDisabledDropDown
          ? (this.modalLabel = 'Add new EOL pyrolysis/gasification')
          : this.modalLabel;
        break;
      case 'admin-eol-ob':
        this.addEditEndpoint = '/EOL_OB/AddUpdateEndofLifeOB';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL open burning') : this.modalLabel;
        break;
      case 'admin-eol-no':
        this.addEditEndpoint = '/EOL_NO/AddUpdateEndofLifeNO';
        !this.isDisabledDropDown ? (this.modalLabel = 'Add new EOL none') : this.modalLabel;
        break;
    }

    this.materialList = this.adminMaterialData.materialItems;

    this.regionList = this.adminMaterialData.regionItems;

    const placeHolderOrganization = {
      name: 'All organizations',
    };
    const newOrganizationlist = [placeHolderOrganization].concat(
      this.adminMaterialData.organizationList
    );
    this.organizationList = newOrganizationlist;
    if (this.adminMaterialData.indicatiorList.length != 0) {
      this.indicatorList = this.adminMaterialData.indicatiorList;
      this.isEolRates = false;
    } else {
      this.indicatorList = this.adminMaterialData.endOfLifeImpactRatesList;
      this.isEolRates = true;
    }
    this.setMaterialList();
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.indicatorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.materialForm = new FormGroup(form);
    this.materialAddEditForm = this.formBuilder.group({
      material: [null, Validators.required],
      region: [null, Validators.required],
      organizationName: [null],
    });
    this.setFormData();
  }

  onChange(value: any) {
    this.materialAddEditForm.controls['region'].reset();
    if (!!value?.id) {
      this.administratorService.GetMaterialRegions(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  async setMaterialList() {
    await this.materialList.map((item: any) => {
      item.childItems.map((x: any, i: any) => {
        if (item.childItems[i]?.id == this.adminMaterialData.materialId) {
          return (this.selectedMaterial = item.childItems[i]);
        }
      });
    });
  }

  async organizatioListFunction() {
    await this.organizationList?.map((item: any) => {
      if (item.id == this.adminMaterialData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.adminMaterialData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }
  setFormData() {
    this.materialAddEditForm.patchValue({
      material: this.selectedMaterial,
      region: this.selectRegion,
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      this.materialAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      !this.materialAddEditForm.controls['region'].value?.name
    ) {
      return;
    }
    if (this.materialAddEditForm.status == 'VALID' && this.materialForm.status == 'VALID') {
      const entires = Object.entries(this.materialForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.indicatorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          id: event.id,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      let materialPayload;
      if (this.isEolRates) {
        materialPayload = {
          materialId: this.materialAddEditForm.controls['material'].value?.id,
          regionId:
            this.materialAddEditForm.controls['region'].value?.id ||
            this.adminMaterialData.regionId,
          organizationId:
            this.materialAddEditForm.controls['organizationName'].value?.name ==
            '--All organization -- '
              ? null
              : this.materialAddEditForm.controls['organizationName'].value?.id,
          endOfLifeImpactRatesList: resultArray,
          endPoint: this.addEditEndpoint,
        };
      } else {
        materialPayload = {
          materialId: this.materialAddEditForm.controls['material'].value?.id,
          regionId:
            this.materialAddEditForm.controls['region'].value?.id ||
            this.adminMaterialData.regionId,
          organizationId:
            this.materialAddEditForm.controls['organizationName'].value?.name ==
            '--All organization -- '
              ? null
              : this.materialAddEditForm.controls['organizationName'].value?.id,
          indicatiorList: resultArray,
          endPoint: this.addEditEndpoint,
        };
      }

      this.saveNewEolEvent.emit(materialPayload);
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  materialInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }
}
